export const museumApiBaseUrl = process.env.NEXT_PUBLIC_MUSEUM_API_BASE_URL
export const museumApiUsername = process.env.MUSEUM_API_USERNAME
export const museumApiPassword = process.env.MUSEUM_API_PASSWORD
